import React, { useEffect, useState } from "react";
import { useIframeUrlMutation } from "../../app/services/DashBoard/adminDashBoardApi";

const MemberOrganisationCategoryView = () => {
    const currentYear = new Date().getFullYear();

    const years = [];
    for (let year = currentYear; year >= 2020; year--) {
        years.push(year);
    }

    const [selectedMember, setSelectedMember] = useState("Active");
    const [selectedYear, setSelectedYear] = useState(currentYear);

    const [iframeUrl, setIframeUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const [iframeUrlApi] = useIframeUrlMutation();

    const fetchIframeUrl = async (
        member = selectedMember,
        year = selectedYear
    ) => {
        setLoading(true);
        setError("");

        try {
            const requestPayload = {
                QuestionId: 60,
                params: {
                    member_type: member,
                    year: year,
                },
                expMinutes: 0,
                bordered: false,
                titled: true,
            };

            const response = await iframeUrlApi(requestPayload).unwrap();

            setIframeUrl(response.iframeUrl);
        } catch (err) {
            console.error(err);
            setError("Failed to fetch iframe URL");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchIframeUrl(selectedMember, selectedYear);
    }, [selectedMember, selectedYear]);

    const handleReload = () => {
        const currentYear = new Date().getFullYear();

        setSelectedMember("Active");
        setSelectedYear(currentYear);

        fetchIframeUrl("Active", currentYear);
    };

    return (
        <div style={{ padding: "20px" }}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                }}
            >
                {/* Left Side - Members Dropdown */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                    }}
                >
                    <label style={{ fontWeight: "600" }}>
                        Members:
                    </label>

                    <select
                        value={selectedMember}
                        onChange={(e) => setSelectedMember(e.target.value)}
                        style={{
                            padding: "6px 12px",
                            minWidth: "120px",
                        }}
                    >
                        <option value="Active">Active</option>
                        <option value="New">New</option>
                    </select>
                </div>

                {/* Right Side - Year Dropdown + Reload */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                    }}
                >
                    <label style={{ fontWeight: "600" }}>
                        Year:
                    </label>

                    <select
                        value={selectedYear}
                        onChange={(e) =>
                            setSelectedYear(Number(e.target.value))
                        }
                        style={{
                            padding: "6px 12px",
                            minWidth: "120px",
                        }}
                    >
                        {years.map((year) => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ))}
                    </select>

                    <button
                        onClick={handleReload}
                        className="btn success-btn reload-btn"
                        disabled={loading}
                    >
                        {loading ? "Loading..." : "Reload Report"}
                    </button>
                </div>
            </div>

            {loading && <p>Loading report...</p>}

            {error && (
                <p style={{ color: "red" }}>
                    {error}
                </p>
            )}

            {iframeUrl && (
                <div className="iframe-main-card">
                    <iframe
                        src={iframeUrl}
                        width="100%"
                        height="600"
                        frameBorder="0"
                        title="Metabase Report"
                    />
                </div>
            )}
        </div>
    );
};

export default MemberOrganisationCategoryView;